import { usePatronTheme, View, Box, Text, Stack, ButtonLink, Button, Inline } from '@unibuddy/patron';
import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { ScrollView, Image } from 'react-native';
import Youtube from 'react-youtube';

var TileHeader = function (_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? "default" : _c;
    var theme = usePatronTheme();
    return (React.createElement(View, { flexDirection: "row", padding: (_b = theme === null || theme === void 0 ? void 0 : theme.TileHeader) === null || _b === void 0 ? void 0 : _b[size].padding }, children));
};

var TileAvatar = function (_a) {
    var _b;
    var url = _a.url, alt = _a.alt, _c = _a.size, size = _c === void 0 ? "default" : _c;
    var theme = usePatronTheme();
    var TileAvatarTheme = (_b = theme === null || theme === void 0 ? void 0 : theme.TileAvatar) === null || _b === void 0 ? void 0 : _b[size];
    var BORDER_WIDTH = 3;
    return (React.createElement(Box, { w: (TileAvatarTheme === null || TileAvatarTheme === void 0 ? void 0 : TileAvatarTheme.size) + BORDER_WIDTH, h: (TileAvatarTheme === null || TileAvatarTheme === void 0 ? void 0 : TileAvatarTheme.size) + BORDER_WIDTH, bgColor: "white", borderRadius: "full", justifyContent: "center", alignItems: "center", display: "flex" },
        React.createElement("img", { alt: alt, src: url, style: {
                width: TileAvatarTheme === null || TileAvatarTheme === void 0 ? void 0 : TileAvatarTheme.size,
                height: TileAvatarTheme === null || TileAvatarTheme === void 0 ? void 0 : TileAvatarTheme.size,
                borderRadius: 1000,
            } })));
};

var TileInfo = function (_a) {
    var _b, _c;
    var name = _a.name, country = _a.country, areaOfStudy = _a.areaOfStudy, _d = _a.size, size = _d === void 0 ? "default" : _d;
    var theme = usePatronTheme();
    var TileInfoTheme = (_b = theme === null || theme === void 0 ? void 0 : theme.TileInfo) === null || _b === void 0 ? void 0 : _b[size];
    var EDGE_HEIGHT = 2;
    return (React.createElement(View, { flex: "1", flexDirection: "column", paddingLeft: (_c = theme === null || theme === void 0 ? void 0 : theme.TileHeader) === null || _c === void 0 ? void 0 : _c[size].horizontalSpace },
        React.createElement(Text, { color: "white", size: TileInfoTheme.titleSize, 
            // @ts-ignore required for truncation
            numberOfLines: 1, truncate: true }, name),
        React.createElement(Box, { paddingTop: TileInfoTheme.verticalSpace }),
        React.createElement(View, { flexDirection: "row", flex: "1", alignItems: "center" },
            country && (React.createElement("img", { style: {
                    width: TileInfoTheme.flagWidth,
                    height: TileInfoTheme.flagHeight,
                    objectFit: "cover",
                }, alt: "Flag ".concat(country.name), src: "https://flagcdn.com/h60/".concat(country.code.toLowerCase(), ".png") })),
            country && areaOfStudy && (React.createElement(Box, { height: TileInfoTheme.flagHeight + EDGE_HEIGHT, w: 1, bgColor: "grey200", marginX: TileInfoTheme.horizontalSpace })),
            React.createElement(Text
            // @ts-ignore - required for truncation
            , { 
                // @ts-ignore - required for truncation
                style: { flex: 1 }, size: TileInfoTheme.subTitleSize, color: "white", numberOfLines: 1, truncate: true }, areaOfStudy))));
};

var DEFAULT_TILE_WIDTH = 290;
var DEFAULT_TILE_HEIGHT = 412;
var TileContext = React.createContext({
    width: DEFAULT_TILE_WIDTH,
    height: DEFAULT_TILE_HEIGHT,
});
var useTileContext = function () { return React.useContext(TileContext); };
var Tile = function (_a) {
    var children = _a.children, _b = _a.width, width = _b === void 0 ? DEFAULT_TILE_WIDTH : _b, _c = _a.height, height = _c === void 0 ? DEFAULT_TILE_HEIGHT : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "grey150" : _d;
    return (React.createElement(TileContext.Provider, { value: { width: width, height: height } },
        React.createElement(View, { position: "relative", borderRadius: "xsmall", overflow: "hidden", flexDirection: "column", bgColor: "white", flexShrink: 0, borderWidth: 1, borderColor: borderColor, w: width, h: height }, children)));
};

var TileWrapper = function (_a) {
    var children = _a.children, callback = _a.callback;
    if (callback) {
        return (React.createElement("div", { onClick: callback, role: "button", style: { cursor: "pointer" } }, children));
    }
    return React.createElement(React.Fragment, null, children);
};

var TileDescription = function (_a) {
    var _b, _c;
    var title = _a.title, description = _a.description, callback = _a.callback, _d = _a.size, size = _d === void 0 ? "default" : _d;
    var theme = usePatronTheme();
    return (React.createElement(TileWrapper, { callback: callback },
        React.createElement(View, { padding: (_b = theme === null || theme === void 0 ? void 0 : theme.TileDescription) === null || _b === void 0 ? void 0 : _b[size].padding },
            React.createElement(Stack, { space: (_c = theme === null || theme === void 0 ? void 0 : theme.TileDescription) === null || _c === void 0 ? void 0 : _c[size].verticalSpace },
                title, description !== null && description !== void 0 ? description : null))));
};

var TileActions = function (_a) {
    var callback = _a.callback, _b = _a.theme, theme = _b === void 0 ? "light" : _b, children = _a.children, link = _a.link, ariaLabel = _a.ariaLabel;
    return (React.createElement(View, { padding: "small-medium", paddingTop: "none" }, link ? (React.createElement(ButtonLink, { block: true, to: link, onClick: callback, color: theme === "light" ? "contentButtonLight" : "contentButtonDark", "aria-label": ariaLabel }, children)) : (React.createElement(Button, { block: true, 
        // @ts-ignore
        onClick: callback, color: theme === "light" ? "contentButtonLight" : "contentButtonDark", "aria-label": ariaLabel }, children))));
};

var ImageSingle = function (_a) {
    var media = _a.media, alt = _a.alt, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: media, style: { width: "100%", height: "100%", objectFit: "cover" }, alt: alt }),
        React.createElement(View, { w: "100%", position: "absolute", zIndex: 10 }, children)));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var MediaCarouselIndicators = function (_a) {
    var count = _a.count, currentIndex = _a.currentIndex;
    return (React.createElement(View, { w: "100%", position: "absolute", flexDirection: "row", justifyContent: "center", bottom: 8, zIndex: 2 }, __spreadArray([], Array(count), true).map(function (_, index) { return (React.createElement(View, { key: index, w: 6, h: 6, borderRadius: "full", bgColor: currentIndex === index ? "white" : "grey500", marginX: "xxsmall" })); })));
};

var BUTTON_SIZE = 32;
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px white;\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px white;\n  }\n"])), BUTTON_SIZE, BUTTON_SIZE);
var ImageCarousel = function (_a) {
    var _b;
    var media = _a.media, children = _a.children, rightIcon = _a.rightIcon, leftIcon = _a.leftIcon, _c = _a.size, size = _c === void 0 ? "default" : _c, _d = _a.autoPlay, autoPlay = _d === void 0 ? true : _d;
    var scrollViewRef = useRef(null);
    var _e = useState(0), currentIndex = _e[0], setCurrentIndex = _e[1];
    var _f = useState(!autoPlay), isPaused = _f[0], setIsPaused = _f[1];
    var theme = usePatronTheme();
    var width = useTileContext().width;
    var handleScroll = function (event) {
        var contentOffsetX = event.nativeEvent.contentOffset.x;
        var newIndex = Math.round(contentOffsetX / width);
        setCurrentIndex(newIndex);
    };
    var handleUserInteraction = function (nextIndex) {
        var _a;
        setIsPaused(true);
        setCurrentIndex(nextIndex);
        (_a = scrollViewRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ x: nextIndex * width, animated: true });
        setTimeout(function () { return setIsPaused(false); }, 3000);
    };
    var scrollPrev = function () {
        var newIndex = currentIndex - 1;
        if (newIndex < 0)
            newIndex = media.length - 1;
        handleUserInteraction(newIndex);
    };
    var scrollNext = function () {
        var newIndex = (currentIndex + 1) % media.length;
        handleUserInteraction(newIndex);
    };
    useEffect(function () {
        if (!autoPlay)
            return;
        if (isPaused)
            return;
        var currentIndex = 0;
        var interval = setInterval(function () {
            var _a;
            currentIndex = (currentIndex + 1) % media.length;
            (_a = scrollViewRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                x: currentIndex * width,
                animated: true,
            });
        }, 3000);
        return function () { return clearInterval(interval); };
    }, [media.length, isPaused, width]);
    var margin = (_b = theme === null || theme === void 0 ? void 0 : theme.TileMedia) === null || _b === void 0 ? void 0 : _b[size].imageCarousel.buttonMargin;
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollView, { ref: scrollViewRef, horizontal: true, pagingEnabled: true, showsHorizontalScrollIndicator: false, indicatorStyle: "white", onScroll: handleScroll, scrollEventThrottle: 100 }, media.map(function (item, index) { return (React.createElement(View, { flex: "1", w: width, h: "100%", key: item },
            React.createElement(Image, { accessibilityLabel: "Image ".concat(index + 1, " of ").concat(media.length), source: { uri: item }, style: { width: "100%", height: "100%" } }))); })),
        React.createElement(MediaCarouselIndicators, { count: media.length, currentIndex: currentIndex }),
        React.createElement(View, { position: "absolute", left: margin, top: "50%", transform: "translateY(-".concat(BUTTON_SIZE / 2, "px)"), zIndex: 100 },
            React.createElement(StyledButton, { size: "sm", color: "contentNavigationButton", iconOnly: true, round: true, onClick: scrollPrev, 
                // @ts-ignore
                accessibilityLabel: "Previous image" }, leftIcon)),
        React.createElement(View, { position: "absolute", right: margin, top: "50%", transform: "translateY(-".concat(BUTTON_SIZE / 2, "px)"), zIndex: 100 },
            React.createElement(StyledButton, { size: "sm", color: "contentNavigationButton", iconOnly: true, round: true, onClick: scrollNext, 
                // @ts-ignore
                accessibilityLabel: "Next image" }, rightIcon)),
        React.createElement(View, { w: "100%", h: "100%", position: "absolute", zIndex: 10 }, children)));
};
var templateObject_1;

var VideoSingle = function (_a) {
    var media = _a.media, children = _a.children, _b = _a.autoPlay, autoPlay = _b === void 0 ? true : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement("video", { src: media, autoPlay: autoPlay, loop: true, muted: true, controls: false, onError: function (err) { return console.log(err); }, style: {
                width: "100%",
                height: "100%",
                objectFit: "cover",
            }, playsInline: true }),
        React.createElement(View, { w: "100%", h: "100%", position: "absolute", zIndex: 10 }, children)));
};

var TopGradient = function () {
    return (React.createElement(View, { position: "absolute", zIndex: 1, height: "30%", width: "100%", style: {
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 40%, rgba(0, 0, 0, 0) 100%)",
        } }));
};
var BottomGradient = function () {
    return (React.createElement(View, { position: "absolute", zIndex: 1, bottom: 0, height: "40%", width: "100%", style: {
            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 40%, rgba(0, 0, 0, 0.7) 100%)",
        } }));
};

var ChevronRightIcon = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
    React.createElement("rect", { width: "32", height: "32", rx: "16", fill: "black", "fill-opacity": "0.8" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.8536 15.9804C19.0488 16.1757 19.0488 16.4923 18.8536 16.6875L13.8536 21.6875C13.6583 21.8828 13.3417 21.8828 13.1464 21.6875C12.9512 21.4923 12.9512 21.1757 13.1464 20.9804L17.7929 16.334L13.1464 11.6875C12.9512 11.4923 12.9512 11.1757 13.1464 10.9804C13.3417 10.7852 13.6583 10.7852 13.8536 10.9804L18.8536 15.9804Z", fill: "white" }))); };
var ChevronLeftIcon = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
    React.createElement("rect", { width: "32", height: "32", rx: "16", fill: "black", "fill-opacity": "0.8" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.1464 16.5196C12.9512 16.3243 12.9512 16.0077 13.1464 15.8125L18.1464 10.8125C18.3417 10.6172 18.6583 10.6172 18.8536 10.8125C19.0488 11.0077 19.0488 11.3243 18.8536 11.5196L14.2071 16.166L18.8536 20.8125C19.0488 21.0077 19.0488 21.3243 18.8536 21.5196C18.6583 21.7148 18.3417 21.7148 18.1464 21.5196L13.1464 16.5196Z", fill: "white" }))); };

var YoutubeVideo = function (_a) {
    var children = _a.children, videoId = _a.videoId, _b = _a.autoPlay, autoPlay = _b === void 0 ? true : _b;
    var opts = {
        height: "100%",
        width: "100%",
        playerVars: {
            autoplay: autoPlay ? 1 : 0,
            loop: 1,
            mute: 1,
            controls: 0,
            playlist: videoId,
        },
    };
    var onPlayerError = function (event) {
        console.log("Youtube player Error:", event.data);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Youtube, { videoId: videoId, opts: opts, onReady: function (event) { autoPlay && event.target.playVideo(); }, onError: onPlayerError, style: {
                display: "flex",
                flex: 1,
            } }),
        React.createElement(View, { w: "100%", h: "100%", position: "absolute", zIndex: 10 }, children)));
};

var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "image";
    MediaType["VIDEO"] = "video";
    MediaType["YOUTUBE"] = "youtube";
})(MediaType || (MediaType = {}));

var TileMedia = function (_a) {
    var children = _a.children, media = _a.media, mediaType = _a.mediaType, _b = _a.justifyContent, justifyContent = _b === void 0 ? "space-between" : _b, _c = _a.size, size = _c === void 0 ? "default" : _c, _d = _a.autoPlay, autoPlay = _d === void 0 ? true : _d, _e = _a.alt, alt = _e === void 0 ? "" : _e;
    var component = (React.createElement(View, { flex: "1", justifyContent: justifyContent }, children));
    if (mediaType === MediaType.IMAGE && typeof media === "string") {
        return (React.createElement(View, { flex: "1", position: "relative" },
            React.createElement(TopGradient, null),
            React.createElement(ImageSingle, { media: media, alt: alt }, component)));
    }
    if (mediaType === MediaType.IMAGE && Array.isArray(media)) {
        return (React.createElement(View, { flex: "1", position: "relative" },
            React.createElement(TopGradient, null),
            React.createElement(ImageCarousel, { autoPlay: autoPlay, size: size, media: media, rightIcon: React.createElement(ChevronRightIcon, null), leftIcon: React.createElement(ChevronLeftIcon, null) }, component),
            React.createElement(BottomGradient, null)));
    }
    if (mediaType === MediaType.VIDEO && typeof media === "string") {
        return (React.createElement(View, { w: "100%", flex: "1", bgColor: "black" },
            React.createElement(TopGradient, null),
            React.createElement(VideoSingle, { media: media, autoPlay: autoPlay }, component),
            React.createElement(BottomGradient, null)));
    }
    if (mediaType === MediaType.YOUTUBE && typeof media === "string") {
        return (React.createElement(View, { w: "100%", flex: "1", bgColor: "black" },
            React.createElement(TopGradient, null),
            React.createElement(YoutubeVideo, { videoId: media, autoPlay: autoPlay }, component),
            React.createElement(BottomGradient, null)));
    }
    return null;
};

var TileBody = function (_a) {
    var _b;
    var children = _a.children, _c = _a.bgColor, bgColor = _c === void 0 ? "white" : _c, _d = _a.justifyContent, justifyContent = _d === void 0 ? "space-between" : _d, _e = _a.size, size = _e === void 0 ? "default" : _e;
    var theme = usePatronTheme();
    return (React.createElement(View, { flex: (_b = theme === null || theme === void 0 ? void 0 : theme.TileBody) === null || _b === void 0 ? void 0 : _b[size].flex, bgColor: bgColor, justifyContent: justifyContent }, children));
};

// Ref: https://github.com/Unibuddy/content-ui/pull/5
var contentUITheme = {
    TileInfo: {
        default: {
            horizontalSpace: "xsmall",
            verticalSpace: "small",
            titleSize: "medium",
            subTitleSize: "small",
            flagWidth: 22,
            flagHeight: 16,
        },
        small: {
            horizontalSpace: "xxsmall",
            verticalSpace: "xsmall",
            titleSize: "small",
            subTitleSize: "xsmall",
            flagWidth: 16,
            flagHeight: 12,
        },
    },
    TileAvatar: {
        default: {
            size: 48,
        },
        small: {
            size: 32,
        },
    },
    TileBody: {
        default: {
            flex: 1,
        },
        small: {
            flex: 0.6,
        },
    },
    TileDescription: {
        default: {
            padding: "small-medium",
            verticalSpace: "small",
        },
        small: {
            padding: "xsmall",
            verticalSpace: "xsmall",
        },
    },
    TileHeader: {
        default: {
            horizontalSpace: "small",
            padding: "small-medium",
        },
        small: {
            horizontalSpace: "xsmall",
            padding: "xsmall",
        },
    },
    TileFooter: {
        default: {
            padding: "small-medium",
            horizontalSpace: "small-medium",
        },
        small: {
            padding: "xsmall",
            horizontalSpace: "small",
        },
    },
    TileMedia: {
        default: {
            imageCarousel: {
                buttonMargin: 16,
            },
            youtubeVideo: {
                marginTop: "xxlarge",
            },
        },
        small: {
            imageCarousel: {
                buttonMargin: 8,
            },
            youtubeVideo: {
                marginTop: "xlarge",
            },
        },
    },
    Button: {
        colors: {
            contentButtonDark: {
                color: "white",
                bgColor: "#131622",
                borderColor: "#131622",
                hoverBgColor: "#414456",
                outlineColor: "#131622",
                clearColor: "#131622",
                clearHoverBgColor: "#131622",
            },
            contentButtonLight: {
                color: "black",
                bgColor: "white",
                borderColor: "white",
                hoverBgColor: "#E2E2E5",
                outlineColor: "white",
                clearColor: "white",
                clearHoverBgColor: "white",
            },
            contentNavigationButton: {
                color: "white",
                bgColor: "black",
                borderColor: "black",
                hoverBgColor: "#414456",
                outlineColor: "black",
                clearColor: "white",
                clearHoverBgColor: "white",
            },
        },
    },
};

var TileFooter = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.size, size = _d === void 0 ? "default" : _d;
    var theme = usePatronTheme();
    return (React.createElement(View, { padding: (_b = theme === null || theme === void 0 ? void 0 : theme.TileFooter) === null || _b === void 0 ? void 0 : _b[size].padding },
        React.createElement(Inline, { space: (_c = theme === null || theme === void 0 ? void 0 : theme.TileFooter) === null || _c === void 0 ? void 0 : _c[size].horizontalSpace, verticalAlign: "center" }, children)));
};

var EyeOpenIcon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "17", height: "16", viewBox: "0 0 17 16", fill: "#5C5F72" }, props),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.49993 3.5C5.6283 3.5 3.19049 5.36268 2.33174 7.94637L2.33169 7.94652C2.31978 7.98232 2.31978 8.02101 2.33169 8.05681C3.19241 10.6393 5.62961 12.5 8.49993 12.5C11.3716 12.5 13.8093 10.6373 14.6674 8.05373L14.668 8.05185C14.68 8.01641 14.6797 7.97937 14.6683 7.94551L14.6676 7.94341C13.8069 5.36077 11.3703 3.5 8.49993 3.5ZM1.38283 7.63081C2.37346 4.65058 5.18494 2.5 8.49993 2.5C11.8136 2.5 14.6236 4.64857 15.6163 7.62725C15.6973 7.8685 15.697 8.12895 15.6161 8.36988C14.6259 11.3498 11.8146 13.5 8.49993 13.5C5.18632 13.5 2.37558 11.3515 1.38291 8.37275L1.38283 8.37252C1.30274 8.13182 1.30273 7.87167 1.38278 7.63096" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.5 6.5C8.10218 6.5 7.72064 6.65804 7.43934 6.93934C7.15804 7.22064 7 7.60218 7 8C7 8.39783 7.15804 8.77936 7.43934 9.06066C7.72064 9.34196 8.10218 9.5 8.5 9.5C8.89783 9.5 9.27936 9.34196 9.56066 9.06066C9.84196 8.77936 10 8.39783 10 8C10 7.60218 9.84196 7.22064 9.56066 6.93934C9.27936 6.65804 8.89783 6.5 8.5 6.5ZM6.73223 6.23223C7.20107 5.76339 7.83696 5.5 8.5 5.5C9.16304 5.5 9.79893 5.76339 10.2678 6.23223C10.7366 6.70107 11 7.33696 11 8C11 8.66304 10.7366 9.29893 10.2678 9.76777C9.79893 10.2366 9.16304 10.5 8.5 10.5C7.83696 10.5 7.20107 10.2366 6.73223 9.76777C6.26339 9.29893 6 8.66304 6 8C6 7.33696 6.26339 6.70107 6.73223 6.23223Z" }))); };

var Article = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement("svg", __assign({ width: "17", height: "16", viewBox: "0 0 17 16", fill: "#5C5F72", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M10.4999 2.33337C10.9419 2.33337 11.3659 2.50897 11.6784 2.82153C11.991 3.13409 12.1666 3.55801 12.1666 4.00004V9.92004L8.41992 13.6667H6.49992C6.05789 13.6667 5.63397 13.4911 5.32141 13.1786C5.00885 12.866 4.83325 12.4421 4.83325 12V4.00004C4.83325 3.55801 5.00885 3.13409 5.32141 2.82153C5.63397 2.50897 6.05789 2.33337 6.49992 2.33337H10.4999ZM10.4999 1.33337H6.49992C5.79267 1.33337 5.1144 1.61433 4.6143 2.11442C4.1142 2.61452 3.83325 3.2928 3.83325 4.00004V12C3.83325 12.7073 4.1142 13.3856 4.6143 13.8857C5.1144 14.3858 5.79267 14.6667 6.49992 14.6667H8.55859C8.73538 14.6667 8.90492 14.5964 9.02992 14.4714L12.9713 10.53C13.0332 10.4681 13.0824 10.3945 13.1159 10.3135C13.1494 10.2325 13.1667 10.1457 13.1666 10.058V4.00004C13.1666 3.2928 12.8856 2.61452 12.3855 2.11442C11.8854 1.61433 11.2072 1.33337 10.4999 1.33337Z", fill: (_a = props.fill) !== null && _a !== void 0 ? _a : "#5C5F72" }),
        React.createElement("path", { d: "M10.5 4.6687H6.5C6.36739 4.6687 6.24022 4.61602 6.14645 4.52225C6.05268 4.42849 6 4.30131 6 4.1687C6 4.03609 6.05268 3.90892 6.14645 3.81515C6.24022 3.72138 6.36739 3.6687 6.5 3.6687H10.5C10.6326 3.6687 10.7598 3.72138 10.8536 3.81515C10.9473 3.90892 11 4.03609 11 4.1687C11 4.30131 10.9473 4.42849 10.8536 4.52225C10.7598 4.61602 10.6326 4.6687 10.5 4.6687Z", fill: (_b = props.fill) !== null && _b !== void 0 ? _b : "#5C5F72" }),
        React.createElement("path", { d: "M8.17333 6.61401H6.5C6.36739 6.61401 6.24022 6.56134 6.14645 6.46757C6.05268 6.3738 6 6.24662 6 6.11401C6 5.98141 6.05268 5.85423 6.14645 5.76046C6.24022 5.66669 6.36739 5.61401 6.5 5.61401H8.17333C8.30594 5.61401 8.43312 5.66669 8.52689 5.76046C8.62066 5.85423 8.67333 5.98141 8.67333 6.11401C8.67333 6.24662 8.62066 6.3738 8.52689 6.46757C8.43312 6.56134 8.30594 6.61401 8.17333 6.61401Z", fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#5C5F72" }),
        React.createElement("path", { d: "M9.33447 14.1374H8.33447V10.9554C8.33483 10.6582 8.4531 10.3732 8.66333 10.1631C8.87357 9.953 9.15858 9.83489 9.45581 9.83472H12.6618V10.8347H9.45581C9.4399 10.8346 9.42414 10.8377 9.40942 10.8437C9.39471 10.8497 9.38133 10.8586 9.37005 10.8698C9.35877 10.881 9.34983 10.8944 9.34372 10.9091C9.33762 10.9237 9.33447 10.9395 9.33447 10.9554V14.1374Z", fill: (_d = props.fill) !== null && _d !== void 0 ? _d : "#5C5F72" })));
};

var VideoCamera = function (props) {
    return (React.createElement("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "#5C5F72", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1 5C1 3.89543 1.89543 3 3 3H9C10.1046 3 11 3.89543 11 5V5.79289L13.2929 3.5C13.9229 2.87003 15 3.3162 15 4.20711V11.7929C15 12.6838 13.9229 13.13 13.2929 12.5L11 10.2071V11C11 12.1046 10.1046 13 9 13H3C1.89543 13 1 12.1046 1 11V5ZM11 8.79289L14 11.7929V4.20711L11 7.20711V8.79289ZM3 4C2.44772 4 2 4.44772 2 5V11C2 11.5523 2.44772 12 3 12H9C9.55229 12 10 11.5523 10 11V5C10 4.44772 9.55229 4 9 4H3Z" })));
};

var Icon = function (_a) {
    var name = _a.name, color = _a.color;
    if (name === "image") {
        return (React.createElement(View, null,
            React.createElement(Article, { fill: color })));
    }
    if (name === "video") {
        return (React.createElement(View, null,
            React.createElement(VideoCamera, { fill: color })));
    }
    if (name === "eyeOpen") {
        return (React.createElement(View, null,
            React.createElement(EyeOpenIcon, { fill: color })));
    }
    return null;
};
var TileIcon = function (_a) {
    var iconName = _a.iconName, text = _a.text, _b = _a.color, color = _b === void 0 ? "#5C5F72" : _b;
    return (React.createElement(View, { gap: "xxsmall", flexDirection: "row", alignItems: "center", flexWrap: "wrap" },
        React.createElement(Icon, { name: iconName, color: color }),
        React.createElement(Text, { nowrap: true, size: "xsmall", color: color }, text)));
};

export { ChevronLeftIcon, ChevronRightIcon, MediaType, Tile, TileActions, TileAvatar, TileBody, TileDescription, TileFooter, TileHeader, TileIcon, TileInfo, TileMedia, contentUITheme, useTileContext };
//# sourceMappingURL=index.js.map
